import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import DownPaymentTracker from '../components/dashboard/DownPaymentTracker.jsx';
import HouseGrid from '../components/dashboard/HouseGrid.jsx';
import { useHousesStore, useAuthStore } from '../store/useStore.js';

export default function Dashboard() {
  const { loadHouses } = useHousesStore();
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    loadHouses().catch(() => {
      // Errors will surface through UI when house list renders; safe to ignore here
    });
  }, [loadHouses]);

  const handleSelectHouse = (house) => {
    navigate(`/houses/${house.id}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-10">
      <div className="max-w-6xl mx-auto px-4 space-y-8">
        <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Welcome Home</h1>
            <p className="text-gray-600">Track your down payment progress and explore the homes you have saved.</p>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors self-start md:self-auto"
          >
            <LogOut className="w-4 h-4" />
            Sign Out
          </button>
        </header>

        <div className="grid gap-6 lg:grid-cols-[minmax(300px,340px)_1fr]">
          <div className="space-y-6">
            <DownPaymentTracker />
          </div>

          <HouseGrid onSelectHouse={handleSelectHouse} />
        </div>
      </div>
    </div>
  );
}
